import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  selectedLanguage = new BehaviorSubject('en');
  constructor() {

  }
}
